import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Password } from 'primeng/password';

@Component({
  selector: 'app-password-fields',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Password],
  templateUrl: './password-fields.component.html',
})
export class PasswordFieldsComponent {
  @Input() group!: FormGroup;
  @Input() confirmControlName = 'confirmPassword';
}
